module.exports = __webpack_public_path__ + "static/img/bg-fr.a7d71b00.png";